import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  FaCcVisa,
  FaUniversity,
  FaCcMastercard,
  FaApplePay,
  FaStar,
} from "react-icons/fa";
import { SiAmericanexpress } from "react-icons/si";
import { sampleCards } from "./data/SampleLoyallyCards";
import { transactions } from "./data/transactions";
import SidebarMenu from "containers/UserDashboard/SideBarMenu";
import StampsTemplate from "./components/StampTemplate";
import {
  ChevronDoubleLeftIcon,
  ChevronLeftIcon,
} from "@heroicons/react/24/outline";
import { FiArrowLeft, FiArrowLeftCircle } from "react-icons/fi";
import RoyaltyCardBack from "containers/Royalty/RoyaltyCardBack";

export default function LoyaltyCardDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const cardId = Number(id);
  const card = sampleCards.find((c) => c.id === cardId);

  const filteredTx = transactions.filter((tx) => tx.cardId === cardId);

  if (!card) {
    return (
      <div className="text-white text-center py-10 text-xl">
        Card not found.
      </div>
    );
  }

  const getBonusIndexes = (stampsselected) => {
    if (stampsselected <= 5) return [stampsselected - 1];
    const numBonuses = stampsselected <= 10 ? 2 : stampsselected <= 15 ? 3 : 4;
    return Array.from(
      { length: numBonuses },
      (_, i) => Math.round(((i + 1) / numBonuses) * stampsselected) - 1
    );
  };

  const bonusIndexes = getBonusIndexes(card.stampsselected);
  const upcomingBonusIndex = bonusIndexes.find(
    (idx) => card.stampCount === idx
  );

  const extendedCard = {
    rewardDetails:
      card.cardDesc4 ||
      "Get $10 off your next purchase after collecting all stamps.",
    terms:
      card.cardDesc5 ||
      "No partial redemptions. Stamps cannot be exchanged or redeemed for cash.",
    contactInfo: card.cardDesc3 || "Unknown Store",
    cardColor: card.CardColor || "#FFC70B",
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen pb-8 pt-12 px-4">
      <div className="container mx-auto px-2">
        <div className="xl:grid grid-cols-8 gap-10 items-start md:py-12 py-0 ">
          <div className="hidden md:block sticky top-16 z-30 col-span-2 bg-gray-800 p-6 rounded-md xl:mb-0 mb-5 max-h-[calc(100vh-4rem)] overflow-y-auto">
            <SidebarMenu />
          </div>
          <div className="col-span-6 rounded-md  p-0 md:p-6">
            <button
              onClick={() =>
                navigate("/loyaltywallet", { state: { status: card?.status } })
              }
              className="flex items-center text-textGray mb-8 text-lg font-medium mb-2 hover:underline"
            >
              {/* Option 1: SVG icon */}
              <FiArrowLeft className="mr-1 font-light" size={40} />
            </button>

            <div className="flex flex-col lg:flex-row gap-4">
              {/* Front Card */}
              <div
                className={`rounded-xl p-5 min-h-[250px] max-w-[400px]  flex flex-col justify-between overflow-hidden w-full lg:w-1/2 ${card.color}`}
              >
                {/* Header */}
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2">
                    <div className="text-white text-2xl">{card.logo}</div>
                    <h2 className="text-lg font-semibold text-white whitespace-nowrap">
                      {card.brand}
                    </h2>
                  </div>

                  <div className="flex items-center gap-1">
                    <div className="flex items-center gap-2 text-white text-sm">
                      <span>
                        {card.stampCount}/{card.stampsselected}
                      </span>
                      {upcomingBonusIndex === undefined && (
                        <span className="uppercase">{card.type}</span>
                      )}
                    </div>
                    {upcomingBonusIndex !== undefined && (
                      <div className="bg-redlight text-text text-xs px-2 py-1 rounded-full flex items-center gap-1 shadow-md animate-pulse">
                        <FaStar size={12} />
                        Bonus {bonusIndexes.indexOf(upcomingBonusIndex) + 1}!
                      </div>
                    )}
                  </div>
                </div>

                {/* Stamps */}
                <div className="py-3 flex justify-start">
                  <StampsTemplate
                    stampsselected={card.stampsselected}
                    stampCount={card.stampCount}
                    pickImg={"/static/media/coffee.0072c842.PNG"}
                    pickunImg={"/static/media/coffee.0072c842.PNG"}
                    stampedBackground={"#FFF"}
                    unstampedBackground={"#FFF"}
                    bonusList={card.bonuses}
                  />
                </div>

                {/* Footer */}
                <div className="flex justify-between items-center text-white">
                  <div className="text-sm tracking-widest">
                    .... {card.last4}
                  </div>
                  <div>{card.icon}</div>
                </div>
              </div>

              {/* Back Card */}
              <div
                className={`rounded-xl p-5 h-[250px] max-w-[400px] flex flex-col justify-between overflow-hidden w-full lg:w-1/2 text-white ${card.color}`}
              >
                <div className="space-y-2 text-sm leading-snug overflow-hidden">
                  <p className="font-semibold text-white">
                    🎁 {extendedCard.rewardDetails}
                  </p>
                  <p className="text-white/80 text-xs whitespace-pre-line">
                    {extendedCard.terms}
                  </p>
                </div>

                {/* <div className="flex flex-wrap gap-2 text-xs mb-2">
                  {card.bonuses.map((bonus, index) => (
                    <span
                      key={index}
                      className="bg-white/20 border border-white/30 px-2 py-1 rounded-full whitespace-nowrap"
                    >
                      🎁 Bonus {index + 1}: {bonus}
                    </span>
                  ))}
                </div> */}

                <div className="flex justify-between items-center text-xs mt-2">
                  <span className="tracking-wide">
                    Contact: {extendedCard.contactInfo}
                  </span>
                  <span className="italic opacity-80">*T&Cs apply</span>
                </div>
              </div>
            </div>

            <h2 className="text-xl font-semibold mb-4 mt-6">
              Latest Transactions
            </h2>
            <div className="space-y-3">
              {filteredTx.length > 0 ? (
                filteredTx.map((tx, index) => (
                  <div
                    key={index}
                    className="bg-[#1e1e1e] rounded-lg px-4 py-3"
                  >
                    <div className="flex justify-between font-medium">
                      <span>{tx.merchant}</span>
                      <span>{tx.amount}</span>
                    </div>
                    <div className="text-sm text-gray-400">{tx.method}</div>
                    {tx.date && (
                      <div className="text-xs text-gray-500">{tx.date}</div>
                    )}
                    {tx.stampreward && (
                      <>
                        <div className="text-xs text-yellow-400 mt-1">
                          +{tx.stampreward} stamp{tx.stampreward > 1 && "s"}
                        </div>
                        <div className="text-[10px] text-gray-400"></div>
                      </>
                    )}
                  </div>
                ))
              ) : (
                <div className="text-sm text-gray-500">
                  No transactions found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
